<template>
    <div class="horizontalChoice" id="colissimoContainer">
        <label class="custom-control custom-radio" v-for="point in colissimoPoints">
            <input v-model="selectedModel" :value="point.identifiant" :id="'input-' + (point.identifiant)" class="custom-control-input input" type="radio" name="colissimo[point]">

            <label :for="'input-' + (point.identifiant)" class="custom-control-label">
                <span class="description-colissimo">
                    <strong>{{ point.nom }}</strong>
                    <span>{{ point.adresse1 }}</span>
                    <span v-if="point.address2">{{ point.adresse2 }}</span>
                    <span v-if="point.address3">{{ point.adresse3 }}</span>
                    <span>{{ point.codePostal }} {{ point.localite }} {{ point.libellePays }}</span>
                </span>
            </label>
        </label>
    </div>
</template>

<script>

// import store from '../../store';

    const OrderInputColissimo = {
        name: 'ponroy-order-input-colissimo',
        // store
        props: {
            colissimoPoints: {
                required: true,
            },
            selected: {
                required: false,
            },
            storeSetColissimoPoint: {
                required: true,
                default: 'order/SET_COLISSIMO_POINT',
            },
        },
        data() {
            return {
                selectedModel: this.selected,
            }
        },
        watch: {
            selected(value) {
                this.selectedModel = value;

                let input = $('#input-' + value);
                let parent = input.parent();
                let index = parent.parent().find('input').index(input);
                $('#colissimoContainer').scrollTop((parent.height()+10) * index);
            },
            selectedModel(value) {
                this.$store.commit(this.storeSetColissimoPoint, value);
            }
        },
    };

    export default OrderInputColissimo;
</script>



// WEBPACK FOOTER //
// src/SiteBundle/Resources/assets/components/Order/OrderInputColissimo.vue